const modes = {
  1: 'Normal',
  2: 'Expert',
  3: 'Ordi',
  4: 'Publique auto',
  5: 'Ultra',
};

export function getLeagueModesWithNames() {
  return modes;
}

export function getLeagueModeName(key) {
  const modes = {
    1: 'Normal',
    2: 'Expert',
    3: 'Ordi',
    4: 'Publique auto',
    5: 'Ultra',
    100: 'Master league normal',
    101: 'Master league expert',
  };

  return modes[key];
}

export function getLeagueStatusName(key) {
  const status = {
    1: 'En cours de création ',
    2: 'Choix mode',
    3: 'En cours de mercato ',
    4: 'Live',
    5: 'Terminé',
    6: 'Garde 3 joueurs',
    7: 'Ventes de joueurs',
  };

  return status[key];
}

export const challengesStatus = {
  completed: 'Terminées',
  inProgress: 'En cours',
  notStarted: 'Lancées',
};



// WEBPACK FOOTER //
// ./src/helpers/league.js